import { render, staticRenderFns } from "./Askingprice.vue?vue&type=template&id=1f236f3f&"
import script from "./Askingprice.vue?vue&type=script&lang=js&"
export * from "./Askingprice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports